// extracted by mini-css-extract-plugin
module.exports = {"content":"Washing_content__2f1_7"};